// extracted by mini-css-extract-plugin
export default {"sidebar":"M1yk8MMA","routeBlock":"_lbwv9DO","routeLink":"BUqDtTUN","routeLinkLabel":"qU_7wlX8","routeStartTime":"RzSg25_c","routeNoAssignment":"RgUJkv7c"};